export default {"src":"/_next/static/media/best-seller.b205958f.svg","height":177,"width":206,"blurWidth":0,"blurHeight":0};